/**
 * 项目基础信息的单值/多值选项集合。
 * 各选项 value 为稳定编码，与后端 cg_project 对应列存储的编码一一对齐；
 * 画面风格的复合选项见 projectArtStyle.ts，游戏变量的结构见 project.ts。
 */
/** 题材类型可选项，value 与后端 cg_project.types 存储编码对齐，允许多选。 */
export const PROJECT_TYPE_OPTIONS = [
    { label: '悬疑', value: 'suspense' },
    { label: '恋爱', value: 'romance' },
    { label: '科幻', value: 'sci-fi' },
    { label: '古风', value: 'ancient' },
    { label: '校园', value: 'campus' },
    { label: '都市', value: 'urban' },
];
/** 预计篇幅可选项，value 与后端 cg_project.duration_tier 存储编码对齐，单选。 */
export const PROJECT_DURATION_TIER_OPTIONS = [
    { label: '短片', value: 'short', description: '5-10 分钟' },
    { label: '中篇', value: 'medium', description: '10-20 分钟' },
    { label: '长篇', value: 'long', description: '20-40 分钟' },
    { label: '不限制', value: 'unlimited', description: '不限时长' },
];
/**
 * 画面比例可选项，value 即「宽:高」标识，与后端 cg_project.screen_ratio 对齐，单选。
 * 只保留横屏与竖屏：方屏（1:1）不再作为项目画面比例对外提供。
 */
export const PROJECT_SCREEN_RATIO_OPTIONS = [
    { label: '横屏', value: '16:9', description: '16:9' },
    { label: '竖屏', value: '9:16', description: '9:16' },
];
/** 互动程度可选项，value 与后端 cg_project.interaction_level 存储编码对齐，单选。 */
export const PROJECT_INTERACTION_LEVEL_OPTIONS = [
    {
        label: '忠于原作',
        value: 'faithful',
        description: '尽量保持原脚本，仅增加必要互动',
    },
    {
        label: '标准改编',
        value: 'standard',
        description: '保留核心剧情，适当增加互动和剧情分支',
    },
    {
        label: '高互动改编',
        value: 'high',
        description: '允许调整部分剧情，增加更多互动和分支',
    },
];
/** 类型编码到中文标签的映射。 */
const TYPE_LABEL_MAP = new Map(PROJECT_TYPE_OPTIONS.map((option) => [option.value, option.label]));
/**
 * 将题材类型编码翻译为中文标签。
 * @param code 题材类型编码。
 * @returns 中文标签，未知编码原样返回。
 */
export function getProjectTypeLabel(code) {
    return TYPE_LABEL_MAP.get(code) ?? code;
}
